import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
  multipleVariations?: boolean;
}

const VariationThreeUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
  multipleVariations,
}) => {
  const settingsApplied = Boolean(
    multipleVariations
      ? image.divider !== 'none' ||
          image.brakes ||
          image.fontSize ||
          getWatermarkTag(image) !== 'none' ||
          image.authorName ||
          (image.nameColor && image.nameColor !== 'black') ||
          (image.channelImageOption && image.channelImageOption !== 'custom')
      : image.divider !== 'none' || getWatermarkTag(image) !== 'none',
  );

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      showText={!!hasText}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          multipleVariations={multipleVariations}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(VariationThreeUploadedImageRow);
